import { gql } from '@apollo/client';

/**
 * A translation is a child of a norm set: which products, seen by which
 * audience. It carries no job — the model comes from its parent, so it keeps
 * rendering against the model the norm set was built on rather than whatever
 * is deployed today.
 *
 * products and demographic are jsonb, which maps to the JSON scalar. id and
 * createdAt are DB-defaulted and must not be sent.
 */
export default gql`
  mutation CreatePerceptionModelProjectTranslation(
    $translation: PerceptionModelProjectTranslationInput!
  ) {
    createPerceptionModelProjectTranslation(
      input: { perceptionModelProjectTranslation: $translation }
    ) {
      perceptionModelProjectTranslation {
        id
        name
        perceptionModelProjectId
        products
        demographic
        createdAt
      }
    }
  }
`;
